import { setPermissions } from '../../ability'
import http from '../http'

export const GLOBAL_VARS_SUCCESS = 'globalVars/GLOBAL_VARS_SUCCESS'
export const GLOBAL_VARS = 'globalVars/GLOBAL_VARS'
export const GLOBAL_ROUTES_UPDATE = 'globalVars/GLOBAL_ROUTES_UPDATE'

export const getGlobalVars = () => dispatch => {
  dispatch({ type: GLOBAL_VARS })
  http.getRequest('/global-vars')
    .then(response => {
      dispatch({
        type: GLOBAL_VARS_SUCCESS,
        vars: response
      })
      dispatch({
        type: 'auth/USER_PROFILE_APP_METADATA',
        app_metadata: response?.user?.app_metadata
      })
      if (response?.user?.app_metadata?.permissions) {
        setPermissions(response.user.app_metadata.permissions)
      }
    })
}

export const updateRoutes = params => ({
  type: GLOBAL_ROUTES_UPDATE,
  params
})
